<template>
	<div>
		<!-- <div
      style="
        position: fixed;
        top: 60px;
        z-index: 10000;
        left: 0px;
        backdrop-filter: blur(2px);
      "
      v-if="loader"
    >
      <Spinner />
    </div> -->

		<div class="height-100dvh" :class="!hasAccess() ? 'logout-mob' : ''">
			<NcdTopContainer
				:title="screenHeaderTitle"
				v-if="
					(showMobileScreen[MOBILE_SCREENS.MAIN_SCREEN] ||
						showMobileScreen[MOBILE_SCREENS.SAVED_JOBS]) &&
					candAccess
				"
			/>
			<div
				class="mob-back-header d-flex align-items-center justify-content-between"
				v-else-if="candAccess"
			>
				<div class="d-flex align-items-center">
					<img
						class="mr-3"
						src="../../assets/mobile/assprog/mobileBackArrow.svg"
						alt=""
						@click="goBack"
					/>
					{{ getCurrentScreenName() }}
				</div>
				<div
					class="d-flex align-items-center pr-4"
					v-if="showMobileScreen[MOBILE_SCREENS.JOB_DETAILS]"
				>
					<img
						@click="goToJobProgress"
						class="mr-4"
						src="../../assets/newdesign/jobsearch/mobjobsearch/appliedJob.svg"
						alt=""
					/>
					<img
						@click="showBookmarkedJobs"
						src="../../assets/newdesign/jobsearch/mobjobsearch/headerBluebookmark.svg"
						alt=""
					/>
				</div>
				<div
					class="d-flex align-items-center pr-4"
					v-else-if="
						showMobileScreen[MOBILE_SCREENS.SAVED_JOBS] &&
						this.$route.query.from != 'sidebar'
					"
				>
					<img
						@click="goToJobProgress"
						src="../../assets/newdesign/jobsearch/mobjobsearch/appliedJob.svg"
						alt=""
					/>
				</div>
			</div>
			<div
				v-if="showMobileScreen[MOBILE_SCREENS.MAIN_SCREEN]"
				class="mob-back-body pt-2 mob-back-job"
			>
				<div class="h-100">
					<div style="margin: 14px 7px">
						<div
							class="mb-header-txt mb-1 d-flex align-items-center header-up-box"
							:class="
								hasAccess()
									? 'justify-content-center'
									: 'justify-content-between'
							"
						>
							<div v-if="!hasAccess()">Job Search</div>
							<div
								class="jobpref-head"
								@click="!hasAccess() ? openLoginModal() : gotojobpref()"
							>
								Set Job Preferences
								<img
									src="@/assets/job-search-icons/mob-rightarw.svg"
									class="ml-1"
									alt=""
								/>
							</div>
						</div>
					</div>
					<div class="tabs-wrapper mt-3">
						<div
							class="new-custom-tab-sect d-flex p-0"
							:class="showBookmarked && 'w-50'"
						>
							<button
								class="tab flex-fill"
								:class="{ active: currentTab === 'hire' }"
								@click="switchTab('hire')"
							>
								<img
									src="../../assets/img/jobsearch/hire3x-mini-logo.svg"
									class="tab-icon mr-2"
									alt=""
								/>
								From Hire3x
							</button>
							<button
								v-if="!showBookmarked"
								class="tab flex-fill"
								:class="{ active: currentTab === 'curated' }"
								@click="switchTab('curated')"
							>
								<img
									src="../../assets/img/jobsearch/curated-img.svg"
									class="tab-icon mr-2 curated-icon"
									alt=""
								/>
								Curated Jobs
							</button>
						</div>
						<div
							class="up-tab-body"
							:class="{
								'hire-active': !showBookmarked && currentTab === 'hire',
								'curated-active': !showBookmarked && currentTab === 'curated',
							}"
						>
							<div class="mobjs-input position-relative gray-field-border">
								<img
									class="mobjs-search-pos"
									src="../../assets/newdesign/jobsearch/blueSearch.svg"
									alt=""
								/>
								<b-form-input
									placeholder="Search by skills, role"
									v-model="tempSearchQuery"
									type="search"
									@update="searchChanged"
									@keyup.enter="
										() => {
											tempSearchQuery && applyFilter();
										}
									"
								></b-form-input>
							</div>
							<div class="mobjs-input position-relative mt-2 gray-field-border">
								<img
									class="mobjs-search-pos"
									src="../../assets/newdesign/jobsearch/blueLocation.svg"
									alt=""
								/>
								<b-form-input
									placeholder="Location"
									v-model="tempLocations"
									type="search"
									@update="searchChanged"
									@keyup.enter="
										() => {
											tempLocations && applyFilter();
										}
									"
								></b-form-input>
							</div>
							<div class="w-100 mt-2 d-flex justify-content-between">
								<div
									@click="toggleFilter"
									class="mobjs-morefilter gray-field-border"
								>
									<div class="position-relative">
										<img
											class="mr-2"
											src="../../assets/newdesign/jobsearch/morefilters.svg"
											alt=""
										/>
										<div v-if="isFiltered" class="laptop-filter-dot"></div>
									</div>
									More Filters
								</div>
								<div
									class="mobjs-bluefilter"
									:class="{ 'opac-5': !isSearchChanged }"
									@click="isSearchChanged ? applyFilter() : null"
								>
									Search
								</div>
							</div>
							<div
								id="jobs"
								:class="!showBookmarked && 'mob-saved-hg'"
								class="mobjs-overflow app-bottom-padding mt-2"
								@scroll="onScroll"
							>
								<div class="mb-black-bold-2 d-flex">
									<div
										v-if="loader && !showBookmarked && (!jobs || !jobs.length)"
									>
										<b-skeleton class="w-75"></b-skeleton>
									</div>
									<div v-else-if="(searchQuery || locations) && total > 0">
										Showing {{ total }} jobs that matches your search result
									</div>
									<div v-else-if="isFiltered && total > 0">
										Showing {{ total }} jobs that matches your filter
									</div>
									<div v-else-if="jobs && jobs.length > 0">List of Jobs</div>
									<div
										class="position-relative mb-grey-txt"
										style="left: 60%"
										v-if="
											!showBookmarked &&
											!isFiltered &&
											!searchQuery &&
											!locations &&
											!bookmarkedSearchQuery &&
											!loader
										"
									>
										Total Jobs: {{ total }}
									</div>
								</div>
								<template v-if="loader && (!jobs || !jobs.length)">
									<div
										v-for="index in 10"
										:key="index"
										class="mobjs-job-cards mt-2"
									>
										<div class="d-flex">
											<div style="height: 30px; width: 30px">
												<b-skeleton
													class="h-100 w-100"
													type="avatar"
												></b-skeleton>
											</div>
											<div class="width-93 pl-2">
												<b-skeleton class="w-50 mt-1"></b-skeleton>
											</div>
										</div>
										<div>
											<b-skeleton class="w-50 mt-1"></b-skeleton>
											<b-skeleton class="w-75 mt-1"></b-skeleton>
											<b-skeleton class="w-75 mt-1"></b-skeleton>
											<b-skeleton class="w-100 mt-1"></b-skeleton>
										</div>
									</div>
								</template>
								<template v-else-if="jobs.length">
									<div
										v-for="(job, index) in jobs"
										:key="index"
										class="mobjs-job-cards mt-2"
										@click="showJobDetails(job)"
									>
										<div
											class="d-flex align-items-center justify-content-between w-100"
										>
											<div
												class="d-flex align-items-center cd-helpsec-cards-viewguide w-85"
											>
												<div class="mobjs-svg-back mr-2">
													<img
														src="../../assets/newdesign/jdprogress/mobjdprog/jdDP.svg"
														alt=""
													/>
												</div>
												<span class="text-truncate w85">{{
													toTitleCase(job.title)
												}}</span>
											</div>
											<div class="d-flex align-items-center">
												<!--<template v-if="job.jobApplied">
											<div class="mb-resume-name pointer">
												<img
													@click.stop="showWithdrawApplication(job)"
													src="../../assets/newdesign/jdprogress/withdrawApplication.svg"
													alt=""
												/>
											</div>
											<div class="asp-vertical-line mx-2"></div>
										</template> -->
												<div v-if="!job.isCurated">
													<img
														v-if="job.bookmarked"
														@click.stop="
															!hasAccess()
																? openLoginModal()
																: toggleBookmark(job)
														"
														src="../../assets/newdesign/jobsearch/filledBookmark.svg"
														alt=""
													/>
													<img
														v-else
														@click.stop="
															!hasAccess()
																? openLoginModal()
																: toggleBookmark(job)
														"
														src="../../assets/newdesign/jobsearch/noFilledBookmard.svg"
														alt=""
													/>
												</div>
											</div>
										</div>
										<div class="js-grey-txt-2 mt-2 pl-2">
											{{
												job.customFields.private_job
													? job.customFields.Board_Organization
													: job.customerName
											}}
										</div>
										<div
											class="d-flex align-items-center mb-grey-txt mt-2 pl-2"
										>
											<div
												class="d-flex align-items-center mr-3 white-space-no-wrap"
												v-if="job.experienceRequired"
											>
												<img
													class="mr-1"
													src="../../assets/newdesign/jdprogress/mobjdprog/jd-exp.svg"
													alt=""
												/>{{ job.experienceRequired }}
												Years
											</div>
											<div
												class="d-flex align-items-center white-space-no-wrap mr-3"
												v-if="job.jobType && !job.isCurated"
											>
												<img
													class="mr-1"
													src="../../assets/newdesign/jdprogress/mobjdprog/jd-fulltime.svg"
													alt=""
												/>{{ toTitleCase(job.jobType) }}
											</div>
											<div
												class="d-flex align-items-center text-truncate"
												style="min-width: 20%; max-width: 37%"
											>
												<img
													class="mr-1"
													src="../../assets/newdesign/jdprogress/mobjdprog/jd-loc.svg"
													alt=""
												/>{{ job.location[0] }}
												<span
													v-if="job.location.length > 1"
													class="viewmore-grey-2 ml-1 pointer text-truncate"
													>+{{ job.location.length - 1 }} more</span
												>
											</div>
										</div>
										<div class="pl-2" v-if="!job.isCurated">
											<span class="mobjd-light-grey-txt mr-1">Skills :</span>
											<span class="mb-grey-txt">
												{{ job.skills[0] }}
												<span v-if="job.skills.length > 1">
													, {{ job.skills[1] }}
												</span>
												<span
													v-if="job.skills.length > 2"
													class="viewmore-grey-2 ml-1 pointer"
												>
													+{{ job.skills.length - 2 }} more
												</span>
											</span>
										</div>

										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="d-flex align-items-center mt-2 pl-2">
												<img
													class="mr-1"
													src="../../assets/newdesign/jobsearch/blueClock.svg"
													alt=""
												/>
												<div class="mb-grey-txt">
													{{ job.postedAt }}
												</div>
											</div>
											<div
												class="padding-apply mobjs-bluefilter mt-1"
												@click.stop="
													!hasAccess()
														? openLoginModal()
														: job.isCurated ||
														  job.customFields.gov_job ||
														  job.customFields.private_job
														? openGovtJobModal(job)
														: goToApplyJob(job)
												"
												v-if="!job.jobApplied && !job.addedByRecruiter"
											>
												Apply
												<img
													class="ml-2"
													src="../../assets/newdesign/jobsearch/whiteRightArrow.svg"
													alt=""
												/>
											</div>
											<div class="padding-apply mobjs-bluefilter mt-1" v-else>
												<img
													class="mr-2"
													src="../../assets/newdesign/jobsearch/whiteDoubleTick.svg"
													alt=""
												/>
												Applied
											</div>
										</div>
									</div>
								</template>
								<template v-else>
									<div
										class="mobjs-overflow-2 d-flex flex-column justify-content-center w-100 align-items-center mt-2"
									>
										<template v-if="isFiltered">
											<img
												src="../../assets/newdesign/jobsearch/searchNotFound.svg"
												alt=""
											/>
											<span class="mb-modal-label mt-4">
												No matching results found for the filter.
											</span>
										</template>
										<template v-else-if="searchQuery || locations">
											<img
												src="../../assets/newdesign/jobsearch/searchNotFound.svg"
												alt=""
											/>
											<span class="mb-modal-label mt-4">
												No matching result for “{{
													[searchQuery, locations].filter((a) => a).join(", ")
												}}”
											</span>
										</template>
										<template v-else>
											<img
												src="../../assets/newdesign/jobsearch/noSavedJobs.svg"
												alt=""
											/>
											<span class="mb-modal-label"> There are no jobs. </span>
										</template>
									</div>
								</template>
								<div v-if="loadingMore" class="d-flex justify-content-center">
									<b-spinner label="Loading..."></b-spinner>
								</div>
							</div>
						</div>
						<NcdBottomContainer v-if="hasAccess()" />
					</div>
				</div>
				<transition name="fade">
					<div
						v-if="!isLaptop && isAnyMobilePopupOpen"
						class="mobile-blur-overlay"
						@click="closeAllPopups"
					></div>
				</transition>
				<Transition name="slidemob">
					<div class="filter-box-mob-2" v-if="showFilter">
						<div class="d-flex justify-content-center mb-black-bold">
							Filter
						</div>
						<div class="d-flex mt-2 h85 justify-content-between">
							<div class="mob-filter-left h-100">
								<div
									v-for="(filter, key) in filteredTabs"
									:key="key"
									:class="
										currentFilterTab === key
											? 'selected-filter'
											: 'normal-filter'
									"
									@click="currentFilterTab = key"
								>
									{{ filter.text }}
								</div>
							</div>
							<div class="mob-filter-right h-100">
								<div
									class="mob-checkbox-group"
									v-if="FILTER_TABS[currentFilterTab].isMulti"
								>
									<b-form-group>
										<b-form-checkbox
											size="sm"
											v-for="option in FILTER_TABS[currentFilterTab].isDynamic
												? dynamicFilters[currentFilterTab]
												: toDropdownOptions(
														FILTER_TABS[currentFilterTab].options
												  )"
											v-model="tempFilters[currentFilterTab]"
											:key="option.value"
											:value="option.value"
										>
											{{ option.text }}
										</b-form-checkbox>
									</b-form-group>
								</div>
								<div
									class="w-100 p-2"
									v-else-if="
										currentFilterTab === 'minSalary' && currentTab === 'curated'
									"
								>
									<div class="mb-3 fs-14 mb-grey-txt-2">Salary more than:</div>
									<div class="d-flex align-items-center w-100">
										<b-button
											class="btn p-0 d-flex align-items-center justify-content-center shadow-none w-32 h-32 fs-16 salary-button"
											:style="{
												backgroundColor:
													(Number(tempFilters.minSalary) || 0) > 0
														? '#1b5b97'
														: '#bac9d8',
											}"
											:disabled="(Number(tempFilters.minSalary) || 0) <= 0"
											@click.prevent="
												$set(
													tempFilters,
													'minSalary',
													Math.max(
														0,
														(Number(tempFilters.minSalary) || 0) - 10000
													)
												)
											"
											>-</b-button
										>
										<b-form-input
											type="text"
											:value="(tempFilters.minSalary || 0) + ' Rs'"
											@input="
												(val) =>
													$set(
														tempFilters,
														'minSalary',
														Number(val.replace(/\D/g, ''))
													)
											"
											@keypress="
												(e) => {
													if (
														e.key !== 'Backspace' &&
														e.key !== 'Delete' &&
														!/[0-9]/.test(e.key)
													)
														e.preventDefault();
												}
											"
											class="mx-3 text-center flex-grow-1 w-100 salary-input"
										></b-form-input>
										<b-button
											class="btn p-0 d-flex align-items-center justify-content-center shadow-none w-32 h-32 fs-16 salary-button"
											@click.prevent="
												$set(
													tempFilters,
													'minSalary',
													(Number(tempFilters.minSalary) || 0) + 10000
												)
											"
											>+</b-button
										>
									</div>
								</div>
								<div class="mob-radio-group" v-else>
									<b-form-group>
										<b-form-radio-group
											size="sm"
											:options="
												FILTER_TABS[currentFilterTab].isDynamic
													? dynamicFilters[currentFilterTab]
													: toDropdownOptions(
															FILTER_TABS[currentFilterTab].options
													  )
											"
											v-model="tempFilters[currentFilterTab]"
											value-field="value"
											text-field="text"
											stacked
										></b-form-radio-group>
									</b-form-group>
								</div>
							</div>
						</div>
						<div
							class="filter-footer d-flex align-items-center justify-content-between mt-2"
						>
							<div class="padding-2-15 mob-cancelBtn mt-1">
								<b-button @click="toggleFilter">Cancel</b-button>
							</div>
							<div class="padding-2-15 mob-cancelBtn mt-1">
								<b-button
									class="mr-3"
									:disabled="!isFilterChanged && !isFiltered"
									@click="resetFilter"
									>Reset</b-button
								>
								<b-button :disabled="!isFilterChanged" @click="applyFilter"
									>Apply</b-button
								>
							</div>
						</div>
					</div>
				</Transition>
				<Transition name="slidemob">
					<div class="filter-box-mob-3" v-if="showCompleteProfileModal">
						<div>
							<div class="cyp-container-top-2 cyp-header-txt-2 pl-3">
								Complete your <br />
								profile
								<div class="cyp-dp-pos">
									<img
										height="100"
										src="../../assets/newdesign/jobsearch/cmp-dp.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="w-100 d-flex flex-column align-items-center">
								<div class="cyp-italic-txt">
									To apply for this job, please complete your<br />
									resume first.
								</div>
								<div class="cyp-black-txt my-4">
									Creating a resume on our platform is quick and easy,<br />
									and it will allow you to showcase your skills and<br />
									experience to potential employers.
								</div>
								<div class="mb-3">
									<b-button class="candash-addBtn" @click="goToDashboard"
										>Create your resume now</b-button
									>
								</div>
							</div>
						</div>
					</div>
				</Transition>
			</div>
			<div
				v-else-if="showMobileScreen[MOBILE_SCREENS.SAVED_JOBS]"
				class="mob-back-body"
			>
				<div class="mob-search-filter position-relative w-100">
					<b-form-input
						placeholder="Search Job"
						type="search"
						debounce="500"
						@update="searchJobs"
						clearable
					></b-form-input>
					<img
						class="mob-search-pos"
						src="../../assets/mobile/assprog/search.svg"
						alt=""
					/>
				</div>
				<template v-if="loader && (!bookmarkedJobs || !bookmarkedJobs.length)">
					<div v-for="index in 10" :key="index" class="mobjs-job-cards mt-2">
						<div class="d-flex">
							<div style="height: 30px; width: 30px">
								<b-skeleton class="h-100 w-100" type="avatar"></b-skeleton>
							</div>
							<div class="width-93 pl-2">
								<b-skeleton class="w-50 mt-1"></b-skeleton>
							</div>
						</div>
						<div>
							<b-skeleton class="w-50 mt-1"></b-skeleton>
							<b-skeleton class="w-75 mt-1"></b-skeleton>
							<b-skeleton class="w-75 mt-1"></b-skeleton>
							<b-skeleton class="w-100 mt-1"></b-skeleton>
						</div>
					</div>
				</template>

				<div
					id="jobs"
					class="mobjs-overflow-2 mt-2"
					v-else-if="bookmarkedJobs && bookmarkedJobs.length > 0"
				>
					<div class="mb-black-bold-2">
						<!-- <div v-if="searchQuery">
              Showing {{ bookmarkedJobs.length }} jobs that matches your search
              result
            </div> -->
						<div>List of Jobs</div>
					</div>
					<div
						v-for="(job, index) in bookmarkedJobs"
						:key="index"
						class="mobjs-job-cards mt-2"
						@click="showJobDetails(job)"
					>
						<div
							class="d-flex align-items-center justify-content-between w-100"
						>
							<div
								class="d-flex align-items-center cd-helpsec-cards-viewguide w-90"
							>
								<div class="mobjs-svg-back mr-2">
									<img
										src="../../assets/newdesign/jdprogress/mobjdprog/jdDP.svg"
										alt=""
									/>
								</div>
								<span class="text-truncate w85">{{
									toTitleCase(job.title)
								}}</span>
							</div>
							<div v-if="!job.isCurated">
								<img
									v-if="job.bookmarked"
									@click.stop="
										!hasAccess() ? openLoginModal() : toggleBookmark(job, true)
									"
									src="../../assets/newdesign/jobsearch/filledBookmark.svg"
									alt=""
								/>
								<img
									v-else
									@click.stop="
										!hasAccess() ? openLoginModal() : toggleBookmark(job, true)
									"
									src="../../assets/newdesign/jobsearch/noFilledBookmard.svg"
									alt=""
								/>
							</div>
						</div>
						<div class="js-grey-txt-2 mt-2 pl-2">
							{{
								job.customFields.private_job
									? job.customFields.Board_Organization
									: job.customerName
							}}
						</div>
						<div class="d-flex align-items-center mb-grey-txt mt-2 pl-2">
							<div
								class="d-flex align-items-center mr-3"
								v-if="job.experienceRequired"
							>
								<img
									class="mr-1"
									src="../../assets/newdesign/jdprogress/mobjdprog/jd-exp.svg"
									alt=""
								/>{{
									job.experienceRequired === "others"
										? "12+"
										: job.experienceRequired
								}}
								Years
							</div>
							<div class="d-flex align-items-center mr-3">
								<img
									class="mr-1"
									src="../../assets/newdesign/jdprogress/mobjdprog/jd-fulltime.svg"
									alt=""
								/>{{ toTitleCase(job.jobType) }}
							</div>
							<div
								class="d-flex align-items-center text-truncate"
								style="min-width: 20%; max-width: 37%"
							>
								<img
									class="mr-1"
									src="../../assets/newdesign/jdprogress/mobjdprog/jd-loc.svg"
									alt=""
								/>{{ job.location[0] }}
								<span
									v-if="job.location.length > 1"
									class="viewmore-grey-2 ml-1 pointer text-truncate"
									>+{{ job.location.length - 1 }} more</span
								>
							</div>
						</div>
						<div class="pl-2">
							<span class="mobjd-light-grey-txt mr-1">Skills :</span>

							<span class="mb-grey-txt">
								{{ job.skills[0] }}
								<span v-if="job.skills.length > 1">
									, {{ job.skills[1] }}
								</span>
								<span
									v-if="job.skills.length > 2"
									class="viewmore-grey-2 ml-1 pointer"
								>
									+{{ job.skills.length - 2 }} more
								</span>
							</span>
						</div>
						<div class="d-flex align-items-center justify-content-between">
							<div class="d-flex align-items-center mt-2 pl-2">
								<img
									class="mr-1"
									src="../../assets/newdesign/jobsearch/blueClock.svg"
									alt=""
								/>
								<div class="mb-grey-txt">
									{{ job.postedAt }}
								</div>
							</div>
							<div
								class="padding-apply mobjs-bluefilter mt-1"
								@click.stop="
									!hasAccess()
										? openLoginModal()
										: job.isCurated ||
										  job.customFields.gov_job ||
										  job.customFields.private_job
										? openGovtJobModal(job)
										: goToApplyJob(job)
								"
								v-if="!job.jobApplied && !job.addedByRecruiter"
							>
								Apply
								<img
									class="ml-2"
									src="../../assets/newdesign/jobsearch/whiteRightArrow.svg"
									alt=""
								/>
							</div>
							<div v-else class="padding-apply mobjs-bluefilter mt-1">
								<img
									class="mr-2"
									src="../../assets/newdesign/jobsearch/whiteDoubleTick.svg"
									alt=""
								/>
								Applied
							</div>
						</div>
					</div>
				</div>
				<div
					class="mobjs-overflow-2 d-flex flex-column justify-content-center w-100 align-items-center mt-2"
					v-else
				>
					<template v-if="bookmarkedSearchQuery">
						<img
							src="../../assets/newdesign/jobsearch/searchNotFound.svg"
							alt=""
						/>
						<span class="mb-modal-label mt-4">
							No matching result for “{{ bookmarkedSearchQuery }}”
						</span>
					</template>
					<template v-else>
						<img
							src="../../assets/newdesign/jobsearch/noSavedJobs.svg"
							alt=""
						/>
						<span class="mb-modal-label"> There are no saved jobs. </span>
					</template>
				</div>
			</div>
			<div
				v-else-if="showMobileScreen[MOBILE_SCREENS.JOB_DETAILS] && selectedJob"
				class="mob-back-body position-relative"
			>
				<div class="h-100">
					<div
						id="job-details"
						class="mobjd-applied-top"
						:class="{ 'loggedout-mobjd-height': !hasAccess() }"
					>
						<div class="mobjd-jobdetails">
							<div
								class="d-flex align-items-start justify-content-between cd-helpsec-cards-viewguide"
							>
								<div class="d-flex align-items-center">
									<div class="mobjd-svg-back mr-2">
										<img
											src="../../assets/newdesign/jdprogress/mobjdprog/jdDP.svg"
											alt=""
										/>
									</div>
									{{ toTitleCase(selectedJob.title) }}
								</div>
								<div v-if="!selectedJob.isCurated">
									<img
										v-if="selectedJob.bookmarked"
										@click.stop="
											!hasAccess()
												? openLoginModal()
												: toggleBookmark(selectedJob)
										"
										src="../../assets/newdesign/jobsearch/filledBookmark.svg"
										alt=""
									/>
									<img
										v-else
										@click.stop="
											!hasAccess()
												? openLoginModal()
												: toggleBookmark(selectedJob)
										"
										src="../../assets/newdesign/jobsearch/noFilledBookmard.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="w-100 d-flex align-items-center">
								<div class="w-50 text-truncate js-grey-txt-2 mt-2 pl-2">
									{{
										selectedJob.customFields.private_job
											? selectedJob.customFields.Board_Organization
											: selectedJob.customerName
									}}
								</div>
								<div
									class="w-50 d-flex justify-content-end"
									v-if="selectedJob.customFields.gov_job"
								>
									<div class="ja-govtjob-tag">
										<img
											src="@/assets/job-search-icons/govt-tag.svg"
											class="mr-1"
											alt=""
										/>Government Job
									</div>
								</div>
							</div>
							<section
								v-if="getgovtids.includes(selectedJob.jobID)"
								class="jobapply-box d-flex align-items-center flex-column mt-3"
							>
								<div class="">
									<div class="mb-black-bold-4">Did you Apply?</div>
									<div class="jobapplysubtext">
										Let us know and we will help you track your application
									</div>
								</div>
								<div class="d-flex text-center justify-content-end w-100 gap-3">
									<div
										class="jobapplybox-btns pointer"
										@click="appliedGovtjob(selectedJob.jobID,selectedJob)"
									>
										Yes
									</div>
									<div
										@click="removeGovtid(selectedJob.jobID)"
										class="jobapplybox-btns pointer"
									>
										No
									</div>
								</div>
							</section>
							<div class="d-flex align-items-center mb-grey-txt mt-2 pl-2">
								<div
									class="d-flex align-items-center mr-3"
									v-if="selectedJob.experienceRequired"
								>
									<img
										class="mr-1"
										src="../../assets/newdesign/jdprogress/mobjdprog/jd-exp.svg"
										alt=""
									/>{{
										selectedJob.experienceRequired === "others"
											? "12+"
											: selectedJob.experienceRequired
									}}
									Years
								</div>
								<div
									class="d-flex align-items-center mr-3"
									v-if="selectedJob.jobType && !selectedJob.isCurated"
								>
									<img
										class="mr-1"
										src="../../assets/newdesign/jdprogress/mobjdprog/jd-fulltime.svg"
										alt=""
									/>{{ toTitleCase(selectedJob.jobType) }}
								</div>
								<div class="d-flex align-items-center">
									<img
										class="mr-1"
										src="../../assets/newdesign/jdprogress/mobjdprog/jd-loc.svg"
										alt=""
									/>{{ selectedJob.location[0] }}
									<span
										v-if="selectedJob.location.length > 1"
										@click="scrollToChild('child2')"
										class="viewmore-grey-2 ml-1 pointer"
										>+{{ selectedJob.location.length - 1 }} more</span
									>
								</div>
							</div>
							<div class="pl-2" v-if="!selectedJob.isCurated">
								<span class="mobjd-light-grey-txt mr-1">Skills :</span
								><span class="mb-grey-txt"
									>{{ arrayToString(selectedJob.skills.slice(0, 4)) }}
									<span
										v-if="selectedJob.skills.length > 4"
										@click="scrollToChild('child1')"
										class="viewmore-grey-2 ml-1 pointer"
										>+{{ selectedJob.skills.length - 4 }} more</span
									></span
								>
							</div>

							<div class="d-flex align-items-center mt-2 pl-2">
								<img
									class="mr-1"
									src="../../assets/newdesign/jobsearch/blueClock.svg"
									alt=""
								/>
								<div class="mb-grey-txt">
									{{ selectedJob.postedAt }}
								</div>
							</div>
							<div class="mobjd-black-txt mt-3">Job Description</div>
							<div
								class="mobjd-light-grey-txt-3 mt-1"
								v-html="selectedJob.description"
							></div>
							<div class="d-flex">
								<div
									class="w-50"
									v-if="selectedJob.minSalary && selectedJob.minSalary > 0"
								>
									<div class="mobjd-black-txt">Minimum CTC</div>
									<div class="mobjd-light-grey-txt-3 mt-1">
										{{ selectedJob.minSalary }} LPA
									</div>
								</div>
								<div
									class="w-50"
									v-if="selectedJob.maxSalary && selectedJob.maxSalary > 0"
								>
									<div class="mobjd-black-txt">Maximum CTC</div>
									<div class="mobjd-light-grey-txt-3 mt-1">
										{{ selectedJob.maxSalary }} LPA
									</div>
								</div>
							</div>
							<div
								class="d-flex mt-3"
								v-if="selectedJob.openingsCount || selectedJob.gender"
							>
								<div class="w-50" v-if="selectedJob.openingsCount">
									<div class="mobjd-black-txt">No. of Openings</div>
									<div class="mobjd-light-grey-txt-3 mt-1">
										{{ selectedJob.openingsCount }}
									</div>
								</div>
								<div class="w-50" v-if="selectedJob.gender">
									<div class="mobjd-black-txt">Gender</div>
									<div class="mobjd-light-grey-txt-3 mt-1">
										{{ selectedJob.gender }}
									</div>
								</div>
							</div>
							<div
								class="d-flex mt-3"
								v-if="
									selectedJob.educationQualification ||
									(selectedJob.customFields && selectedJob.customFields.shift)
								"
							>
								<div class="w-50" v-if="selectedJob.educationQualification">
									<div class="mobjd-black-txt">Education</div>
									<div class="mobjd-light-grey-txt-3 mt-1">
										{{ selectedJob.educationQualification }}
									</div>
								</div>
								<div
									class="w-50"
									v-if="
										selectedJob.customFields && selectedJob.customFields.shift
									"
								>
									<div class="mobjd-black-txt">Shift</div>
									<div class="mobjd-light-grey-txt-3 mt-1">
										{{ selectedJob.customFields.shift }}
									</div>
								</div>
							</div>
							<div class="d-flex mt-3" v-if="selectedJob.workingTime">
								<!-- <div class="w-50">
                  <div class="mobjd-black-txt">Work Type</div>
                  <div class="mobjd-light-grey-txt-3 mt-1">Remote</div>
                </div> -->
								<div class="w-50" v-if="selectedJob.workingTime">
									<div class="mobjd-black-txt">Working Hours</div>
									<div class="mobjd-light-grey-txt-3 mt-1">
										{{ selectedJob.workingTime }}
									</div>
								</div>
							</div>
							<div class="d-flex mt-3" v-if="selectedJob.noticePeriod">
								<div class="w-50">
									<div class="mobjd-black-txt">Notice Period</div>
									<div class="mobjd-light-grey-txt-3 mt-1">
										{{ selectedJob.noticePeriod }}
									</div>
								</div>
							</div>
							<div ref="child2" class="mobjd-black-txt mt-3">Locations</div>
							<div class="mobjd-light-grey-txt-3 mt-1">
								{{ arrayToString(selectedJob.location) }}
							</div>
							<div
								ref="child1"
								class="mobjd-black-txt mt-3"
								v-if="selectedJob.skillsToLearn.length > 0"
							>
								Skills
							</div>
							<div
								class="mobjd-light-grey-txt-3 mt-1"
								v-if="selectedJob.skillsToLearn.length > 0"
							>
								{{ arrayToString(selectedJob.skills) }}
							</div>
							<template v-if="selectedJob.skillsToLearn.length > 0">
								<div
									class="d-flex align-items-center justify-content-between mt-4"
								>
									<div class="mobjd-black-txt">
										Skills mentioned in this job description are not found in
										your profile:
									</div>
									<div>
										<img
											class="ml-1"
											src="../../assets/newdesign/jdprogress/trans-AI.svg"
											alt
										/>
									</div>
								</div>
								<div class="mobjd-italic-txt mt-2">
									Increase your chances of getting hired by 2x
								</div>
								<div class="d-flex flex-wrap mt-1">
									<div
										v-for="(skill, index) in selectedJob.skillsToLearn"
										:key="index"
										class="jdp-skill-tag mr-2 mb-2"
									>
										{{ skill }}
									</div>
								</div>
								<div class="d-flex justify-content-center py-2">
									<b-button
										@click="!hasAccess() ? openLoginModal() : openJobMatch()"
										class="candash-addBtn-sm"
										>Check job match</b-button
									>
								</div>
							</template>
							<template v-if="!selectedJob.isCurated">
								<div class="mb-black-bold mt-3">
									Practice for the job inteview
								</div>

								<div
									class="flex-1 mt-2 d-flex align-items-center justify-content-between gap-2 interview-card pointer"
									@click="
										!hasAccess()
											? openLoginModal()
											: goToMockInterview(selectedJob)
									"
								>
									<div class="flex-1 d-flex align-items-center gap-3">
										<img
											src="../../assets/newdesign/jobsearch/take-mock.svg"
											alt=""
										/>
										<div>
											<div class="fam-mont fw-M fs-14 text-blue">
												Take Mock Interview
											</div>
											<div class="fam-lato fw-R fs-12 text-headtext mt-1">
												Learn practical, in-demand skills to stay ahead in your
												career journey.
											</div>
										</div>
									</div>
									<img
										height="24"
										width="24"
										src="../../assets/newdesign/myprofile/roundRightArrow.svg"
										alt=""
									/>
								</div>
								<div
									class="flex-1 mt-3 d-flex align-items-center justify-content-between gap-2 interview-card pointer"
									@click="
										!hasAccess()
											? openLoginModal()
											: goToInterviewPrep(selectedJob)
									"
								>
									<div class="flex-1 d-flex align-items-center gap-3">
										<img
											src="../../assets/newdesign/jobsearch/preopInter.svg"
											alt=""
										/>
										<div>
											<div class="fam-mont fw-M fs-14 text-blue">
												Prepare for Interview
											</div>
											<div class="fam-lato fw-R fs-12 text-headtext mt-1">
												Learn practical, in-demand skills to stay ahead in your
												career journey.
											</div>
										</div>
									</div>
									<img
										height="24"
										width="24"
										src="../../assets/newdesign/myprofile/roundRightArrow.svg"
										alt=""
									/>
								</div>
							</template>
							<template
								v-if="
									(!relatedAssessments || relatedAssessments.length) &&
									!selectedJob.customFields.gov_job
								"
							>
								<div class="mobjd-black-txt mt-2">
									Assessments to practice for this job
								</div>
								<template v-if="!relatedAssessments">
									<AssessmentCardSkeleton
										v-for="index in 1"
										:key="index + 'assessment'"
										customClass="assesspro-cards w-100 mt-2"
										:isMobile="true"
									/>
								</template>
								<template v-else
									><div
										v-for="(assessment, index) in relatedAssessments"
										:key="'assessment' + index"
										class="carousel-assesspro-cards-1 w-100 mt-2 mb-0"
									>
										<div class="asp-top-card pb-2">
											<div>
												<img
													src="../../assets/newdesign/assessPro/assDP.svg"
													alt=""
												/>
											</div>
											<div class="pl-2 width-93">
												<div
													class="mb-blue-txt-3 text-break text-left w-90 text-capitalize"
												>
													{{ assessment.testName }}
												</div>
												<div class="js-light-txt mt-1 text-left">
													Topic Name :
												</div>
												<div class="mb-mobile-txt text-truncate w-90 text-left">
													{{ assessment.topicName }}
												</div>
											</div>
										</div>
										<div
											class="d-flex align-items-center justify-content-between mt-1"
										>
											<div class="d-flex">
												<div class="d-flex align-items-center js-light-txt">
													<img
														class="mr-1"
														src="../../assets/newdesign/assessPro/sandClock.svg"
														alt=""
													/>
													{{ assessment.config.testDuration }}
													Min(s)
												</div>
												<div class="asp-vertical-line ml-2 mr-2"></div>
												<div class="d-flex align-items-center">
													<img
														class="mr-2"
														src="../../assets/newdesign/assessPro/level.svg"
														alt=""
													/>
													<div class="d-flex align-items-center">
														<span class="js-light-txt">Level :</span
														><span class="mb-black-txt ml-1"
															>0{{ assessment.intDifficulty }}</span
														>
													</div>
												</div>
											</div>
											<!-- <div class="d-flex align-items-center asp-blue-txt">
                    Take Test
                    <img
                      class="ml-1"
                      src="../../assets/newdesign/assessPro/blueRightArrow.svg"
                      alt=""
                    />
                  </div> -->
											<div
												v-if="isUpcoming(assessment)"
												class="d-flex align-items-center asp-blue-txt"
												@click="viewTestDetails(assessment, true)"
											>
												Take Test
												<img
													class="ml-1"
													src="../../assets/newdesign/assessPro/blueRightArrow.svg"
													alt=""
												/>
											</div>
											<!-- <div
                   v-if="isUpcoming(assessment)"
                  class="d-flex align-items-center asp-blue-txt asp-yellow-txt"
                > 
                  Notified
                  <img
                    class="mr-1"
                    src="../../assets/mobile/assprog/yellowTick.svg"
                    alt=""
                  />
                </div> -->
											<div
												v-else-if="assessment.noOfAttemptsTaken == 0"
												class="d-flex align-items-center asp-blue-txt"
												@click="viewTestDetails(assessment, true)"
											>
												Take Test
												<img
													class="ml-1"
													src="../../assets/newdesign/assessPro/blueRightArrow.svg"
													alt=""
												/>
											</div>
											<div v-else class="d-flex align-items-center">
												<div
													v-if="assessment.attemptsLeft == 0"
													class="mob-completed-tag mr-1"
												>
													Completed
												</div>
												<div
													v-if="assessment.attemptsLeft == 0"
													class="d-flex align-items-center asp-blue-txt"
													@click="viewMarks(assessment)"
												>
													View Marks
													<img
														class="ml-1"
														src="../../assets/newdesign/assessPro/viewMark.svg"
														alt=""
													/>
												</div>
												<div
													v-if="assessment.attemptsLeft != 0"
													class="d-flex align-items-center asp-blue-txt"
													@click="viewTestDetails(assessment, true)"
												>
													Retake Test
													<img
														class="ml-1"
														src="../../assets/newdesign/assessPro/blueRightArrow.svg"
														alt=""
													/>
												</div>
											</div>
										</div>
									</div>
								</template>
							</template>
							<template v-if="!relatedJobs || relatedJobs.length">
								<div class="mobjd-black-txt mt-2">Similar Jobs</div>
								<template v-if="!relatedJobs">
									<div
										v-for="index in 1"
										:key="index + 'job'"
										class="assesspro-cards w-100 mt-2"
									>
										<div class="d-flex">
											<div style="height: 31px; width: 31px">
												<b-skeleton
													class="h-100 w-100"
													type="avatar"
												></b-skeleton>
											</div>
											<div class="width-93 pl-2">
												<b-skeleton class="w-50 mt-2"></b-skeleton>
												<b-skeleton class="w-25 mt-4"></b-skeleton>
												<b-skeleton class="w-100"></b-skeleton>
											</div>
										</div>
										<hr />
										<div class="w-100">
											<b-skeleton class="w-100"></b-skeleton>
										</div>
									</div>
								</template>
								<template v-else>
									<div
										v-for="(job, index) in relatedJobs"
										:key="'job' + index"
										class="carousel-assesspro-cards-2 w-100 mt-2 mb-0"
										@click="showJobDetails(job)"
									>
										<div class="d-flex">
											<div>
												<img
													src="../../assets/newdesign/jobsearch/roundJobDp.svg"
													alt=""
												/>
											</div>
											<div class="pl-2 width-93">
												<div
													class="d-flex justify-content-between align-items-center w-100"
												>
													<div
														class="mb-blue-txt-3 text-truncate text-left w-75 text-capitalize"
													>
														{{ toTitleCase(job.title) || "--" }}
													</div>
													<div
														@click.stop="
															!hasAccess()
																? openLoginModal()
																: toggleBookmark(job, true)
														"
													>
														<img
															v-if="job.bookmarked"
															src="../../assets/newdesign/jobsearch/filledBookmark.svg"
															alt=""
														/>
														<img
															v-else
															src="../../assets/newdesign/jobsearch/noFilledBookmard.svg"
															alt=""
														/>
													</div>
												</div>
												<div class="mb-mobile-txt text-left mt-1">
													{{
														job.customFields.private_job
															? job.customFields.Board_Organization
															: job.customerName
													}}
												</div>
												<div class="d-flex align-items-center cd-hs-pi-sh mt-1">
													<div>
														{{ arrayToString(job.location) }}
													</div>
													<div class="mb-dot ml-2 mr-2"></div>
													<div>
														{{ toTitleCase(job.jobType) }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
							</template>
						</div>
					</div>
					<div class="mobjd-applied-footer w-100 px-3">
						<div class="mob-cancelBtn w-50 pr-2">
							<b-button class="w-100" @click="goBack">Cancel</b-button>
						</div>
						<div class="mob-addBtn w-50 pl-2">
							<b-button
								@click.stop="
									!hasAccess()
										? openLoginModal()
										: selectedJob.isCurated || selectedJob.customFields.gov_job
										? openGovtJobModal(selectedJob)
										: goToApplyJob(selectedJob)
								"
								class="w-100"
								v-if="!selectedJob.jobApplied && !selectedJob.addedByRecruiter"
								>Apply</b-button
							>
							<b-button v-else disabled class="w-100">Applied</b-button>
						</div>
					</div>
				</div>

				<Transition name="slidemob">
					<div class="filter-box-mob-3" v-if="showCompleteProfileModal">
						<div>
							<div class="cyp-container-top-2 cyp-header-txt-2 pl-3">
								Complete your <br />
								profile
								<div class="cyp-dp-pos">
									<img
										height="100"
										src="../../assets/newdesign/jobsearch/cmp-dp.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="w-100 d-flex flex-column align-items-center">
								<div class="cyp-italic-txt">
									To apply for this job, please complete your<br />
									resume first.
								</div>
								<div class="cyp-black-txt my-4">
									Creating a resume on our platform is quick and easy,<br />
									and it will allow you to showcase your skills and<br />
									experience to potential employers.
								</div>
								<div class="mb-3">
									<b-button class="candash-addBtn" @click="goToDashboard"
										>Create your resume now</b-button
									>
								</div>
							</div>
						</div>
					</div>
				</Transition>
			</div>
			<div
				v-else-if="showMobileScreen[MOBILE_SCREENS.JOB_DETAILS]"
				class="mob-back-body d-flex align-items-center justify-content-center"
				style="height: 80vh"
			>
				<Loader />
			</div>
			<!-- <div
				v-if="showJobMatch"
				class="mob-back-body position-relative overflow-auto"
			>
				<JobMatch
				:job="jobToMatch" />
			</div> -->
			<ApplyJobForm
				v-else-if="showMobileScreen[MOBILE_SCREENS.APPLY_JOB]"
				@close="goBack"
				@success="handleJobApplicationSuccess($event, true)"
				@failure="errorModal('Error', $event)"
				:job="selectedJob"
				:licenseKey="selectedJob.licenseKey"
				:candidateData="candidateData"
			/>
		</div>
		<b-modal
			v-if="showWithdrawApplicationModal"
			v-model="showWithdrawApplicationModal"
			size="md"
			centered
			hide-footer
			hide-header
			@hidden="showWithdrawApplicationModal = false"
		>
			<div class="w-100">
				<div class="d-flex flex-column align-items-center no-border-bottom p-3">
					<img
						class="mr-3"
						src="../../assets/newdesign/jdprogress/withdrawAppDP.svg"
						alt=""
					/>
					<div class="d-flex justify-content-between mt-2">
						<div class="candash-modal-head">Withdraw Application</div>
						<div
							class="d-flex justify-content-end pointer cross-icon-pos"
							:class="{ 'opac-5': buttonLoader }"
							@click="!buttonLoader && (showWithdrawApplicationModal = false)"
						>
							<img
								src="../../assets/newdesign/dashboard/blueCross.svg"
								alt=""
							/>
						</div>
					</div>
					<div class="candash-modal-label text-center mt-2 pr-3">
						Are you sure you want to withdraw
						<span style="color: #20639b"
							>“{{ toTitleCase(selectedJob.title) }}”</span
						>
						application
					</div>
				</div>

				<div
					class="p-3 no-border-top d-flex align-items-center justify-content-center"
				>
					<div
						class="width-120px candash-cancelBtn mr-4"
						:class="{ 'opac-5': buttonLoader }"
						@click="!buttonLoader && (showWithdrawApplicationModal = false)"
					>
						Cancel
					</div>

					<div class="mob-addBtn position-relative">
						<b-button
							:class="
								buttonLoader
									? 'loader-class-withdraw-mob defaultCursor'
									: 'candash-addBtn'
							"
							@click="!buttonLoader && withdrawApplication(selectedJob)"
							>{{ buttonLoader ? "" : "Withdraw" }}</b-button
						>
						<div v-if="buttonLoader" class="loader-pos-new">
							<Loader />
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal
			v-if="showCannotWithdrawApplicationModal"
			v-model="showCannotWithdrawApplicationModal"
			size="md"
			centered
			hide-footer
			hide-header
			@hidden="showCannotWithdrawApplicationModal = false"
		>
			<div class="w-100">
				<div class="d-flex flex-column align-items-center no-border-bottom p-3">
					<img
						class="mr-3"
						src="../../assets/newdesign/jdprogress/withdrawAppDP.svg"
						alt=""
					/>
					<div class="d-flex justify-content-between mt-2">
						<div class="candash-modal-head">Cannot Withdraw Application</div>
						<div
							class="d-flex justify-content-end pointer cross-icon-pos"
							@click="showCannotWithdrawApplicationModal = false"
						>
							<img
								src="../../assets/newdesign/dashboard/blueCross.svg"
								alt=""
							/>
						</div>
					</div>
					<div class="candash-modal-label text-center mt-2 pr-3">
						The application for this job has already been selected, so you
						cannot withdraw it.
					</div>
				</div>

				<div
					class="p-3 no-border-top d-flex align-items-center justify-content-center"
				>
					<b-button
						class="candash-addBtn"
						@click="showCannotWithdrawApplicationModal = false"
						>Okay</b-button
					>
				</div>
			</div>
		</b-modal>
		<Govtjobs
			v-if="govtJobModal"
			@storeid="storeGovtId"
			:showmodal="govtJobModal"
			:selectedJob="selectedJob"
			@close-modal="govtJobModal = false"
		/>
		<PaymentComingSoonModal :showModal.sync="showPaymentComingSoonModal" />
		<FormModal
			v-if="showForm"
			:showModal="showForm"
			:formType="formType"
			:form="selectedForm"
			:fromJobSearch="true"
			@data-added="refreshCandidateInfo"
			@skip-modal="handleDismissModal"
			@close-modal="showForm = false"
		/>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import jobSearch from "@/components/mixin/jobSearch";
import ApplyJobForm from "@/views/JobSearch/ApplyJobForm.vue";
import toast from "@/components/mixin/toast";
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";
import Loader from "@/components/fixedcomponents/Loader.vue";
import JobMatch from "@/components/JobSearch/JobMatch.vue";
import NcdBottomContainer from "@/components/NewCandidateDashboard/NcdBottomContainer.vue";
import Govtjobs from "@/components/JobSearch/GovtJobs.vue";
import { getCustomFields } from "../../utils/customField.js";
import { trackJobApplied } from '@/utils/posthogHelpers.js';
import { getProcessedToken } from "@/utils/request";
import { getCandidateDetail } from "../../controllers/dashboard/asynchronous";
import { required, email, maxLength } from "vuelidate/lib/validators";
import { hasAccess } from "@/utils/tokenCheck.js";
import { config } from "@/config/index.js";
import {
	applyJob,
	getCandidateFilePaths,
	getJobPreference,
	applyCuratedJobs,
	getCandidatePrimaryProfile,
	getCandidateOnboard,
} from "../../utils/apiFunctions.js";
import AssessmentCardSkeleton from "@/components/Assessment/AssessmentCardSkeleton.vue";
import FormModal from "@/components/BuilderPage/FormModal.vue";
export default {
	name: "MobileJobSearch",
	components: {
		// TestDetailsMobile,
		ApplyJobForm,
		NcdTopContainer,
		Loader,
		JobMatch,
		Govtjobs,
		AssessmentCardSkeleton,
		FormModal,
		NcdBottomContainer,
	},
	mixins: [jobSearch, toast],
	data() {
		return {
			showJobMatch: false,
			newObject: {},
			customFieldsArray: [],
			touchedFields: [],
			mobgovtjobs: false,
			loopvar: 10,
			loopvar2: 2,
			resumescreen: false,
			savedjobsscreen: false,
			jobdetailsscreen: true,
			options: [
				{ text: "Orange", value: "orange" },
				{ text: "Apple", value: "apple" },
				{ text: "Pineapple", value: "pineapple" },
				{ text: "Grape", value: "grape" },
				{ text: "Orange", value: "orange" },
				{ text: "Apple", value: "apple" },
			],
			showForm: false,
			selectedForm: null,
			formType: "add",
			formCheckTimeout: null,
			showMoreMenu: false,
			windowWidth: window.innerWidth,
		};
	},
	mounted() {
		window.addEventListener("popstate", () => {
			if (sessionStorage.getItem("fromResumeClinic")) {
				this.$router.replace({
					path: this.$route.path,
					query: {
						...this.$route.query,
						from: "resumeclinicModal",
					},
				});
			}
		});
		if (this.hasAccess()) {
			this.formCheckTimeout = setTimeout(() => {
				this.checkAndOpenFormModal();
			}, 10000);
		}
		window.addEventListener("resize", this.onResize);
	},
	beforeDestroy() {
		if (this.formCheckTimeout) clearTimeout(this.formCheckTimeout);
		window.removeEventListener("resize", this.onResize);
	},
	created() {},
	computed: {
		screenHeaderTitle() {
			// Saved Jobs is a sub-screen of the JobSearch route whose meta title
			// is "Job Search", so drive its header title here; other screens fall
			// back to $route.meta.title.
			if (this.showMobileScreen[this.MOBILE_SCREENS.SAVED_JOBS]) {
				return "Saved Jobs";
			}
			return "";
		},
		newobjectskillsStringArray() {
			return this.primaryCandidateInfo.skills.map((obj) => obj.skillName);
		},
		...mapGetters("userVUEX", {
			userinfo: "getUserInfo",
			candAccess: "getCandAccess",
		}),
		...mapGetters("candidateVUEX", {
			primaryCandidateInfo: "getPrimaryCandidateInfo",
			getgovtids: "getgovtids",
		}),
		...mapGetters("candidateVUEX", {
			candidateProgress: "getCandProgressRespPrimary",
		}),

		filteredTabs() {
			if (this.currentTab === "hire") {
				return this.FILTER_TABS;
			}
			return Object.fromEntries(
				Object.entries(this.FILTER_TABS).filter(([key]) => key === "minSalary")
			);
		},
		isLaptop() {
			return this.windowWidth >= 1028;
		},
		isAnyMobilePopupOpen() {
			return (
				this.showMoreMenu || this.showFilter || this.showCompleteProfileModal
			);
		},
	},
	beforeRouteLeave(to, from, next) {
		if (from.query.from === "resumeclinicModal") {
			if (from.query.fromPage === "ProfileVisibility") {
				if (
					to.name === "ProfileVisibility" &&
					to.query.from !== "resumeclinicModal"
				) {
					next({
						name: "ProfileVisibility",
						query: {
							...to.query,
							from: "resumeclinicModal",
						},
					});
					return;
				}
			} else if (
				to.name === "MyProfile" &&
				to.query.from !== "resumeclinicModal"
			) {
				next({
					name: "MyProfile",
					query: {
						...to.query,
						from: "resumeclinicModal",
					},
				});
				return;
			}
		}
		next();
	},
	methods: {
		closeAllPopups() {
			this.showMoreMenu = false;
			this.showFilter = false;
			this.showCompleteProfileModal = false;
		},
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		async checkAndOpenFormModal() {
			// if (!this.primaryCandidateInfo) return;
			try {
				const onboardRes = await getCandidateOnboard();
				const onboardData = onboardRes?.data?.data;
				if (onboardData?.onboardingCompleted === false) {
					return;
				}
			} catch (err) {
				console.error("[LaptopJobSearch] getCandidateOnboard error:", err);
			}

			// Check if modal was dismissed in the last hour
			const lastDismissed = localStorage.getItem("lastDismissedProfileModal");
			const oneHour = 60 * 60 * 1000;
			if (lastDismissed && Date.now() - parseInt(lastDismissed) < oneHour) {
				return;
			}

			const info = this.primaryCandidateInfo;

			const expLevel = info.experienceLevel;

			if (
				expLevel === "fresher" &&
				(!info.educationalInfo || info.educationalInfo.length === 0)
			) {
				this.selectedForm = {
					formID: "education",
					formName: "Educational Info",
					selectedTabOnCrud: "education",
				};
				this.formType = "add";
				this.showForm = true;
			} else if (
				expLevel &&
				expLevel !== "fresher" &&
				(!info.experience || info.experience.length === 0)
			) {
				this.selectedForm = {
					formID: "experience",
					formName: "Experience Info",
					selectedTabOnCrud: "experience",
				};
				this.formType = "add";
				this.showForm = true;
			}
		},
		handleDismissModal() {
			this.showForm = false;
			localStorage.setItem("lastDismissedProfileModal", Date.now().toString());
		},
		async refreshCandidateInfo() {
			try {
				// Use no-id endpoint to always fetch the primary profile, not a stale per-profile id from the store.
				const res = await getCandidatePrimaryProfile();
				if (res.status === 200 && res.data.data) {
					this.$store.commit("candidateVUEX/setPrimaryProfile", res.data.data);
				}
			} catch (error) {
				console.error("Error refreshing candidate info:", error);
			}
		},
		hasAccess() {
			return hasAccess();
		},
		openJobMatch() {
			this.showJobMatch = true;
			this.$router.push({
				name: "JobMatch",
				params: { job: this.selectedJob },
			});
		},
		gotojobpref() {
			this.$router.push({
				name: "JobPreference",
			});
		},
		storeGovtId(id) {
			console.log(id);
			this.$store.commit("candidateVUEX/storegovtids", id);
		},
		removeGovtid(id) {
			this.$store.commit("candidateVUEX/removegovtid", id);
		},
		async appliedGovtjob(jobid,job) {
			try {
				if (this.selectedJob.isCurated) {
					await applyCuratedJobs({
						jobID: this.selectedJob.jobID,
					});
					this.selectedJob.jobApplied = true;
					this.removeGovtid(jobid);
					this.successModal("Success", "Applied Successfully");
					this.page = 0;
					this.jobs = null;
					await this.getCuratedJobs();
					return;
				}
				const customFields = await getCustomFields(
					"5",
					"add",
					this.selectedJob.licenseKey
				);
				if (customFields.length) {
					[this.customFieldsArray, this.newObject, this.touchedFields] =
						customFields;
				}

				// Prepare candidate info mappings
				const candidateInfo = this.primaryCandidateInfo;
				const res1 = await getCandidateFilePaths(this.primaryCandidateInfo._id);
				if (res1.status == 200) {
					candidateInfo.resume = res1.data.data.resumePath;
				}

				// Populate the `newObject` with candidate information
				const keys = Object.keys(this.newObject.customFields);
				Object.assign(this.newObject, {
					resume: candidateInfo.resume,
					email: candidateInfo.email,
					experince: candidateInfo.totalYearsOfExp,
					name: candidateInfo.fullName,
					phoneNumber: candidateInfo.phoneNumber,
					skills: this.newobjectskillsStringArray,
					otherSource: "Hire3x",
					source: "other",
					customFields: {
						...this.newObject.customFields,
						altPhoneNumber: candidateInfo.altPhoneNumber,
						currentCTC: candidateInfo.currentCTC,
						expectedCTC: candidateInfo.expectedCTC,
						gender: candidateInfo.gender,
						willingToRelocate: candidateInfo.willingToRelocate,
						willingToRelocateTo: candidateInfo.willingToRelocateTo,
						noticePeriod: candidateInfo.noticePeriod,
					},
				});
				const payload = {
					emailID: candidateInfo.email,
					jobID: jobid,
					firstName: candidateInfo.firstName,
					lastName: candidateInfo.lastName,
					location: candidateInfo.city,
					phoneNumber: candidateInfo.phoneNumber,
					candidateInfo: {
						...this.newObject,
						userID: this.userinfo.userID,
					},
				};
				console.log(payload);

				// Uncomment to apply for the job and handle the response
				const res = await applyJob(payload);
				if (res.status === 200) {
					// this.$emit("success", jobid);
					trackJobApplied(job)
					this.handleJobApplicationSuccess(jobid);
					this.removeGovtid(jobid);
				} else {
					throw new Error(res.data.data.Detail);
				}
			} catch (error) {
				console.error("Error in appliedgovtjob:", error);
			}
		},

		scrollToChild(childRef) {
			const target = this.$refs[childRef];

			if (target) {
				target.scrollIntoView({ behavior: "smooth" });
			}
		},
		goToApplyJob(job) {
			this.trackEvent("job_apply_intent", { jobID: job.jobID });
			// if (this.candidateProgress.progress >= 20) {
			this.selectedJob = job;
			this.currentMobileScreen = this.MOBILE_SCREENS.APPLY_JOB;
			if (!job.isCurated) this.getTrendingJob(job.jobID);
			// } else {
			// 	this.showCompleteProfileModal = true;
			// }
		},
		goBack() {
			const fromQuery = this.$route.query.from;
			const fromProject = this.$route.query.fromProject;
			const isResumeClinic =
				(Array.isArray(fromQuery)
					? fromQuery.includes("resumeclinicModal")
					: fromQuery === "resumeclinicModal") || !!fromProject;

			if (isResumeClinic) {
				const fromPage = this.$route.query.fromPage;

				// If coming from the training platform, redirect back there
				if (fromProject) {
					window.location.href = `${config.trainingBase}/${fromProject}`;
					return;
				}

				if (fromPage === "ProfileVisibility") {
					this.$router.push({
						name: "ProfileVisibility",
						query: {
							from: "resumeclinicModal",
						},
					});
					return;
				}
				this.$router.push({
					name: fromPage || "JobSearch",
					query: {
						from: "resumeclinicModal",
					},
				});
			} else {
				this.showCompleteProfileModal = false;
				if (this.showMobileScreen[this.MOBILE_SCREENS.SAVED_JOBS]) {
					this.showBookmarked = false;
					this.$router.go(-1);
					this.getJobs(true);
				} else if (
					this.showMobileScreen[this.MOBILE_SCREENS.JOB_DETAILS] &&
					this.$route.query.jobID
				) {
					this.$router.push({
						name: "JobSearch",
						query: {
							...this.$route.query,
							screen: undefined,
							jobID: undefined,
						},
					});
				} else {
					this.$router.go(-1);
				}
			}
		},

		goToOnlineCourses() {
			this.showMoreMenu = false;
			window.location.href = `${this.config.websiteBase}#courses`;
		},
	},
	watch: {
		"$route.query.bookmarked"(bookmarked) {
			if (bookmarked) {
				this.currentMobileScreen = this.MOBILE_SCREENS.SAVED_JOBS;
			}
		},
		currentMobileScreen() {
			// Sync the browser tab title with the active sub-screen. The route
			// meta only reflects the parent route (e.g. "Job Search"), so the
			// Saved Jobs sub-screen needs its own tab title here.
			const tabTitle =
				this.currentMobileScreen === this.MOBILE_SCREENS.SAVED_JOBS
					? "Saved Jobs"
					: this.$route.meta.title;
			document.title = tabTitle
				? `${tabTitle} - Candidate Portal`
				: "Candidate Portal";

			if (this.currentMobileScreen === this.$route.query.screen) {
				return;
			}
			let jobID = this.currentMobileScreen === this.MOBILE_SCREENS.JOB_DETAILS 
				? (this.selectedJob && this.selectedJob.jobID ? this.selectedJob.jobID : this.$route.query.jobID) 
				: this.$route.query.jobID ? this.$route.query.jobID  :  undefined;

			if (this.currentMobileScreen === this.MOBILE_SCREENS.SAVED_JOBS) jobID = null;
			if (!this.$route.query.screen) {
				this.$router.replace({
					query: {
						// ...this.$route.query,
						fromProject: this.$route.query.fromProject,
						screen: this.currentMobileScreen,
						bookmarked: this.$route.query.bookmarked,
						from: this.$route.query.from,
						searchQuery: this.$route.query.searchQuery,
						locations: this.$route.query.locations,
						jobID: jobID,
						fromPage: this.$route.query.fromPage,
					},
				}).catch((err) => {
					if (err.name !== "NavigationDuplicated") throw err;
				});
			} else {
				this.$router.push({
					query: {
						// ...this.$route.query,
						fromProject: this.$route.query.fromProject,
						screen: this.currentMobileScreen,
						bookmarked: this.$route.query.bookmarked,
						from: this.$route.query.from,
						searchQuery: this.$route.query.searchQuery,
						locations: this.$route.query.locations,
						jobID: jobID,
						fromPage: this.$route.query.fromPage,
					},
				}).catch((err) => {
					if (err.name !== "NavigationDuplicated") throw err;
				});
			}
		},
		"$route.query.screen"(currentScreen) {
			if (currentScreen === this.MOBILE_SCREENS.SAVED_JOBS) {
				this.searchQuery = "";
				this.tempSearchQuery = "";
				this.tempLocations = "";
				this.page = 0;
				this.jobs = null;
				this.filters = { ...this.TEMP_FILTERS };
				this.filters[this.SORT_BY_TAB] = this.extractSortBy(
					this.tempFilters[this.SORT_BY_TAB]
				);
				this.showBookmarkedJobs();
			} else if (currentScreen === this.MOBILE_SCREENS.MAIN_SCREEN) {
				this.bookmarkedSearchQuery = "";
				this.page = 0;
				this.bookmarkedJobs = null;
				this.currentMobileScreen = this.MOBILE_SCREENS.MAIN_SCREEN;
				this.showBookmarked = false;
				if (this.currentTab === "curated") {
					this.getCuratedJobs();
				} else {
					this.getJobs(true);
				}
			} else if (!currentScreen) {
				this.jobs = null;
				this.bookmarkedJobs = null;
				this.showBookmarked = false;
				this.page = 0;
				this.currentMobileScreen = this.MOBILE_SCREENS.MAIN_SCREEN;
				if (this.currentTab === "curated") {
					this.getCuratedJobs();
				} else {
					this.getJobs(true);
				}
			} else {
				this.currentMobileScreen = currentScreen;
				if (
					currentScreen === this.MOBILE_SCREENS.JOB_DETAILS &&
					this.$route.query.jobID
				) {
					if (
						!this.selectedJob ||
						this.selectedJob.jobID !== this.$route.query.jobID
					) {
						const listToSearch = this.showBookmarked
							? this.bookmarkedJobs
							: this.jobs;
						const matchedJob = (listToSearch || []).find(
							(j) => j.jobID === this.$route.query.jobID
						);
						if (matchedJob) {
							this.showJobDetails(matchedJob, false);
						}
					}
				}
			}
		},
	},
};
</script>
<style>
.jobpref-head {
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 15px;
	color: #20639b;
}
.salary-button {
	border-radius: 50%;
	min-width: 32px;
	min-height: 32px;
	line-height: 1;
	color: #ffffff;
	background-color: #1b5b97;
}
.salary-button:active,
.salary-button:focus {
	background-color: #1b5b97 !important;
}

.salary-input {
	border-radius: 4px;
	border: 1px solid #eaedf0;
}

.salary-button-disabled {
	background-color: #bac9d8;
}
</style>

<style lang="postcss" scoped>
.loader-pos-withdraw-mob {
	position: absolute;
	top: -53px;
	z-index: 1;
	left: 19px;
}

.loader-class-withdraw-mob {
	height: 31.5px !important;
	width: 130.5px !important;
	opacity: 0.5;
}

/* Mobile view */
@media (max-width: 768px) {
	.new-custom-tab-sect .tab {
		padding: 0 !important;
	}
	.up-tab-body {
		background: #ffffff;
		padding: 10px 15px !important;
	}
	.new-custom-tab-sect {
		gap: 0;
	}
	.new-custom-tab-sect .tab:not(.active) {
		margin-inline: 12px;
	}
}
.up-tab-body.hire-active {
	border-radius: 0px 12px 0px 0px;
	border: 1px solid #20639b;
}

.up-tab-body.curated-active {
	border-radius: 12px 0px 0px 0px;
	border: 1px solid #20639b;
}

.mob-back-job {
	padding: 0 !important;
}
.header-up-box {
	padding: 12px 15px;
	background: radial-gradient(
		100% 100% at 50.05% 0%,
		rgba(255, 255, 255, 0.25) 0%,
		rgba(87, 164, 255, 0.2) 100%
	);
	border: 1px solid rgba(226, 232, 240, 0.15);
	box-shadow: 0px 10px 15px -3px rgba(88, 28, 135, 0.05),
		0px 4px 6px -4px rgba(88, 28, 135, 0.05);
	backdrop-filter: blur(6px);
	/* Note: backdrop-filter has minimal browser support */
	border-radius: 16px;
}

.new-custom-tab-sect .tab.active .curated-icon {
	filter: brightness(0) invert(1);
}
.mob-salary-filter-dropdown {
	height: 45px;
	font-size: 14px;
}
.filter-box-mob-2 {
	z-index: 9999;
	position: fixed;
}
.loggedout-mobjd-height {
	height: 82% !important;
}
</style>
